<template>
    <slick class="application-carousel" :class="{ isIgnition: isIgnition }" ref="applicationKanban"
           :options="slickOptions">
        <div v-for="stage in filteredStages" class="drag-column" :class="{ ['drag-column-' + stage.value]: true }"
             :key="stage.value">
			<span class="drag-column-header">
				<slot :name="stage.label">
					{{ stage.label }}
				</slot>
				<span v-if="getapplications(stage)" class="counter">{{ getStageTotal(stage.value) }}</span>
			</span>
            <div class="drag-options"></div>
            <ul
                class="drag-inner-list"
                :ref="`list-${stage.value}`"
                :data-status="stage.label"
                :data-id="stage.value"
                v-infinite-scroll="loadMore(stage)"
                infinite-scroll-distance="10"
                :infinite-scroll-throttle-delay="500"
                :infinite-scroll-immediate-check="false"
            >
                <li
                    class="drag-item"
                    v-for="application in getapplications(stage)"
                    :data-application-id="application.id"
                    :key="`${application.ref_id}-${application.asset}`"
                >

                    <slot :name="application.ref_id">
                        <el-link
                            :underline="false"
                            @click.capture="
								(e) =>
									onClickCapture(
										e,
										application.search_url +
											(!isReferrer
												? _.get(
														stages.find((e) => e.value == application.application_status_id),
														'stageUrl',
														''
												  )
												: '')
									)
							"
                            target="_blank"
                            class="w-100"
                        >
                            <el-card
                                shadow="hover"
                                :class="`application-${_.get(application,'application_type',_.get(application, 'business_name') != '' ? 2 : 1)}`"

                                :body-style="{ padding: '0px' }"
                            >
                                <div slot="header" class="d-flex justify-content-between align-items-center w-100">
                                    <div
                                        class="amb-check-container amb-table-check-container d-flex align-items-center">
                                        <input v-if="canAssignApp" class="table-checkbox" type="checkbox"
                                               v-model="checked[application.id]"/>
                                        <span class="amb-table-checkmark"></span>
                                        <div
                                            class="checkmark-favicon"
                                            v-if="!checked[application.id]"
                                            :style="{
                                                backgroundImage: `url(${
                                                    application.is_insurance_deal ? icons['Insurance'] : icons[_.get(application, 'asset', 'Personal')]
                                                }`,
                                            }"
                                        />

                                        <span class="ml-2 app-ref text-nowrap text-truncate">
                                            {{
                                                application.loan_approved_applicant ? application.loan_approved_applicant.full_name : application.customer_name
                                            }}
                                            <br v-if="application.business_name"/>
                                            <small v-if="application.business_name">
                                                <i>{{ application.business_name }}</i>
                                            </small>
                                        </span>
                                    </div>
                                    <el-tag>${{ application.amount || "0.00" }}</el-tag>
                                </div>
                                <div class="card-table">
                                    <table class="table mb-0">
                                        <tbody>
                                        <tr v-if="application.applicant_1_phone">
                                            <td>Phone</td>
                                            <td>
													<span @click.stop>
														<el-link
                                                            icon="el-icon-phone"
                                                            :href="`tel://${
																(_.get(config, 'call_prefix') != null ? config.call_prefix : '') +
																application.applicant_1_phone.toString().replace(/\s+/g, '')
															}`"
                                                        >
															{{ application.applicant_1_phone.toString().replace(/\s+/g, "") }}
														</el-link>
													</span>
                                            </td>
                                        </tr>
                                        <tr v-else-if="application.customer_phone">
                                            <td>Phone</td>
                                            <td>
													<span @click.stop>
														<el-link
                                                            icon="el-icon-phone"
                                                            :href="`tel://${
																(_.get(config, 'call_prefix') != null ? config.call_prefix : '') +
																application.customer_phone.toString().replace(/\s+/g, '')
															}`"
                                                        >
															{{ application.customer_phone.toString().replace(/\s+/g, "") }}
														</el-link>
													</span>
                                            </td>
                                        </tr>
                                        <tr v-if="_.get(application, 'postcode')">
                                            <td>Postcode:</td>
                                            <td>{{ _.get(application, 'postcode') }}</td>
                                        </tr>
                                        <!-- <tr v-if="(application.broker_name && canAssignApp) || (application.broker_name && canViewAllApps)"> -->
                                        <tr>
                                            <td>Assigned:</td>
                                            <td>{{ application.broker_name }}</td>
                                        </tr>
                                        <tr v-if="application.support_users && Object.keys(application.support_users).length">
                                            <td>Support:</td>
                                            <td>{{ Object.values(application.support_users).join(", ") }}</td>
                                        </tr>
                                        <tr v-if="application.referrer">
                                            <td>Referrer:</td>
                                            <td>{{ application.referrer || "None" }}</td>
                                        </tr>
                                        <tr v-if="application.referrer && application.referrer != 'Credit Concierge'">
                                            <td>Referrer User:</td>
                                            <td>{{ application.referrer_user || "None" }}</td>
                                        </tr>
                                        <tr v-if="!_.isEmpty(application.application_categories)">
                                            <td>Categories:</td>
                                            <td class="category-item">
                                                    <span v-for="uid in application.application_categories" :key="uid">
                                                        <el-tooltip class="item" effect="dark"
                                                                    :content="getCategory(uid, 'name')" placement="top">
                                                            <div
                                                                :style="`background: ${getCategory(uid, 'colour')} !important`"
                                                                class="category-dot">&nbsp;</div>
                                                        </el-tooltip>
                                                    </span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <div class="mt-2 mb-2 d-flex w-100 justify-content-between align-items-center">
                                        <div class="d-flex w-50 justify-content-start align-items-center">
                                            <el-tag v-if="application.application_status" type="grey" size="small">
                                                {{
                                                    _.get(application, "application_status.name", application.application_status)
                                                }}
                                            </el-tag>
                                            <el-tag v-if="application.is_insurance_deal" type="success" size="small">
                                                Insurance
                                            </el-tag>
                                        </div>
                                        <el-tooltip class="item" effect="dark" content="Time in stage" placement="top">
                                            <el-tag v-if="_.get(application, 'last_stage_change')" type="info-time"
                                                    size="small">
                                                {{ application.last_stage_change | moment("from", "now") }}
                                            </el-tag>
                                        </el-tooltip>
                                    </div>
                                </div>
                                <div class="card-footer" @click.stop>
                                    <div class="d-flex justify-content-between align-items-center">
                                        <el-row>
                                            <el-tooltip class="item" effect="dark" content="Tasks" placement="bottom">
                                                <el-button
                                                    icon="fas fa-tasks"
                                                    circle
                                                    size="mini"
                                                    @click.prevent="tasksModal(application)"
                                                    :type="checkTaskStatus(application.tasks)"
                                                ></el-button>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" content="Add Note"
                                                        placement="bottom">
                                                <el-popover
                                                    v-if="application.last_note != null"
                                                    placement="top"
                                                    :title="application.last_note.notes"
                                                    width="auto"
                                                    popper-class="max-400"
                                                    trigger="hover"
                                                    :content="(application.last_note.updated_at + 'Z') | moment('DD/MM/YYYY LT')"
                                                >
                                                    <el-button
                                                        slot="reference"
                                                        @click.prevent="createNote(application)"
                                                        icon="el-icon-edit"
                                                        circle
                                                        size="mini"
                                                        class="ml-2 note"
                                                        type="warning"
                                                    ></el-button>
                                                </el-popover>
                                                <el-button
                                                    v-else
                                                    icon="el-icon-edit"
                                                    @click.prevent="createNote(application)"
                                                    circle
                                                    size="mini"
                                                ></el-button>
                                            </el-tooltip>

                                            <el-tooltip
                                                v-if="Ambition.getGlobal('tenant.pbx_active') && stage.label == 'Leads'"
                                                class="item" effect="dark" content="Call History" placement="bottom">
                                                <el-popover
                                                    placement="top"
                                                    width="auto"
                                                    popper-class="max-400"
                                                    trigger="hover">
                                                    <table v-if="_.get(application, 'call_history.0')"
                                                           class="table mb-0 mini">
                                                        <tbody>
                                                        <tr v-for="call in application.call_history" :key="call.id">
                                                            <td><strong>{{
                                                                    call.created_at + "Z" | moment("ddd DD/MM/YY LT")
                                                                }}</strong></td>
                                                            <td v-html="call.message"></td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    <div v-else>No Calls Available</div>
                                                    <el-button @click.prevent="" slot="reference" icon="el-icon-phone"
                                                               circle size="mini" class="mx-2"
                                                               :type="checkSameDay(_.get(application, 'contacted.datetime')) ? _.get(application, 'contacted.status', 'danger') : 'danger'"></el-button>
                                                </el-popover>
                                            </el-tooltip>
                                            <el-tooltip
                                                v-if="Ambition.getGlobal('tenant.pbx_active') && stage.label != 'Leads'"
                                                class="item" effect="dark" content="Call History" placement="bottom">
                                                <el-popover
                                                    :disabled="hover"
                                                    placement="top"
                                                    width="auto"
                                                    popper-class="max-400"
                                                    trigger="hover">
                                                    <table v-if="_.get(application, 'call_history.0')"
                                                           class="table mb-0 mini">
                                                        <tbody>
                                                        <tr v-for="call in application.call_history" :key="call.id">
                                                            <td><strong>{{
                                                                    call.created_at + "Z" | moment("ddd DD/MM/YY LT")
                                                                }}</strong></td>
                                                            <td v-html="call.message"></td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    <div v-else>No Calls Available</div>
                                                    <el-button @click.prevent="" slot="reference" icon="el-icon-phone"
                                                               circle size="mini" class="mx-2"></el-button>
                                                </el-popover>
                                            </el-tooltip>

                                            <el-tooltip class="item" effect="dark" content="Send Message"
                                                        placement="bottom">
                                                <el-button
                                                    icon="el-icon-message"
                                                    @click.prevent="sendMessage(application.id)"
                                                    circle
                                                    size="mini"
                                                ></el-button>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" content="History" placement="bottom">
                                                <el-popover
                                                    :disabled="hover"
                                                    placement="top"
                                                    width="auto"
                                                    popper-class="max-400"
                                                    trigger="hover">
                                                    <table class="table mb-0 mini">
                                                        <tbody>
                                                        <tr v-if="_.get(application, 'created_at')">
                                                            <td><strong>Created:</strong></td>
                                                            <td>{{
                                                                    application.created_at | moment("ddd DD/MM/YY LT")
                                                                }}
                                                            </td>
                                                        </tr>
                                                        <tr v-if="_.get(application, 'updated_at')">
                                                            <td><strong>Last Updated:</strong></td>
                                                            <td>{{
                                                                    application.updated_at | moment("ddd DD/MM/YY LT")
                                                                }}
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    <div v-if="_.get(application, 'all_history')">
                                                        <h4 class="mt-2">Application History</h4>
                                                        <hr/>
                                                        <table class="table mb-0 mini">
                                                            <tbody v-if="_.get(application, 'all_history')">
                                                            <tr v-for="history in application.all_history"
                                                                :key="history.id">
                                                                <td>
                                                                    <strong>{{
                                                                            (history.created_at + "Z") | moment("ddd DD/MM/YY LT")
                                                                        }}</strong>
                                                                </td>
                                                                <td v-html="history.message"></td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <el-button
                                                        @click.prevent=""
                                                        slot="reference"
                                                        icon="el-icon-time"
                                                        circle
                                                        size="mini"
                                                        class="mx-2"
                                                    ></el-button>
                                                </el-popover>
                                            </el-tooltip>
                                            <el-tooltip class="item" effect="dark" content="Expected Delivery Date"
                                                        placement="bottom"
                                                        v-if="_.get(application, 'assetObject.additional.expectedDate')">
                                                <el-popover
                                                    v-if="_.get(application, 'assetObject.additional.expectedDate')"
                                                    placement="top"
                                                    :title="'Expected Delivery Date is on the ' +_.get(application, 'assetObject.additional.expectedDate')"
                                                    width="auto"
                                                    popper-class="max-400"
                                                    trigger="hover"
                                                    :content="(_.get(application, 'updated_at')) | moment('DD/MM/YYYY LT')"
                                                >
                                                    <el-button
                                                        slot="reference"
                                                        @click.prevent=""
                                                        icon="el-icon-date"
                                                        circle
                                                        size="mini"
                                                        class="ml-2 note"
                                                        type="warning"
                                                    ></el-button>
                                                </el-popover>
                                            </el-tooltip>
                                        </el-row>
                                        <el-popover
                                            v-if="application.approved_lender != null || application.last_submitted_loan_tier != null"
                                            placement="top"
                                            :title="
												application.approved_loan_tier ? application.approved_loan_tier : application.last_approved_loan_tier
											"
                                            width="auto"
                                            popper-class="max-400"
                                            trigger="hover"
                                            :content="application.approved_lender ? application.approved_lender : application.last_submitted_loan_tier"
                                        >
                                            <el-image
                                                slot="reference"
                                                class="d-flex justify-content-end align-items-center lender-image"
                                                v-if="
													application.approved_lender_logo != null ? true : application.last_submitted_lender_logo ? true : false
												"
                                                style="width: 100px; height: 28px; mix-blend-mode: multiply"
                                                :src="
													application.approved_lender_logo != null
														? application.approved_lender_logo
														: application.last_submitted_lender_logo
												"
                                                fit="contain"
                                            >
                                                <div slot="error" class="image-slot">
                                                    <i class="el-icon-picture-outline"></i>
                                                </div>
                                            </el-image>
                                        </el-popover>

                                        <el-tag
                                            v-if="stage.label == 'Leads'"
                                            size="mini"
                                            :type="application.fast_tracked ? 'danger' : 'success'">

                                            {{ application.fast_tracked ? "Hot Lead" : "New" }}
                                        </el-tag>
                                    </div>
                                </div>
                            </el-card>
                        </el-link>
                    </slot>
                </li>
            </ul>
            <div class="drag-column-footer" v-loading="stage.busy">
                <slot :name="`footer-${stage.value}`"></slot>
            </div>
        </div>
    </slick>
</template>

<script>
import Slick from "vue-slick"
import {mapGetters} from "vuex"
import InfiniteLoading from "vue-infinite-loading"
import moment from "moment-timezone"

export default {
    name: "ApplicationsKanbanBoardView",
    components: {
        Slick,
        InfiniteLoading,
    },
    props: {
        stages: {
            type: Array,
            required: true,
        },
        applications: {
            type: Object,
            required: true,
        },
        config: {
            type: Object,
            default: () => ({}),
        },
        tokenInitial: {
            required: false,
        },
        isBroker: {
            required: false,
        },
        viewUnassigned: {
            required: false,
        },
        closeReasons: {
            required: false,
        },
        canAssignApp: {
            required: false,
        },
        canViewAllApps: {
            required: false,
        },
        isReferrer: {
            required: false,
        },
        referrerUserId: {
            required: false,
        },
        referrerId: {
            required: false,
        },
        canMakeInsuranceDeal: {
            required: false,
        },
        isIgnition: {
            type: Boolean,
        },
        icons: {
            required: true,
        },
        sortby: {
            type: Object,
        },
    },

    data() {
        return {
            slickOptions: {
                infinite: false,
                speed: 100,
                slidesToShow: 9,
                slidesToScroll: 1,
                swipeToSlide: true,
                touchMove: true,
                dots: false,
                respondTo: "slider",
                responsive: [
                    {
                        breakpoint: 3000,
                        settings: {
                            slidesToShow: 6,
                        },
                    },
                    {
                        breakpoint: 2200,
                        settings: {
                            slidesToShow: 5,
                        },
                    },
                    {
                        breakpoint: 1776,
                        settings: {
                            slidesToShow: 4,
                        },
                    },
                    {
                        breakpoint: 1400,
                        settings: {
                            slidesToShow: 3,
                        },
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                ],
            },
            dragging: false,
            hover: false,
        }
    },

    computed: {
        ...mapGetters({
            applicationTabView: "userSettings/applicationTabView",
            applicationCategories: "options/applicationCategories",
        }),
        checked: {
            get() {
                return this.$store.getters["applicationsDashboard/getChecked"]
            },
            set(data) {
                this.$store.dispatch("applicationsDashboard/setChecked", data);
            }
        },

        filteredStages() {
            return this.stages.filter((stage) => {
                if (this.applicationTabView == "compact") {
                    return stage.hide != true
                } else {
                    return stage.depreciated != true
                }
            })
        },

        localapplications() {
            return this.applications
        },

        compactApplications() {
            return Object.keys(this.applications).reduce((result, key) => {
                let array = this.applications[key]
                let stageIndex = this.stages.findIndex((stage) => {
                    return stage.value == key
                })
                let newKey = this.stages[stageIndex].moveCardsTo != null ? this.stages[stageIndex].moveCardsTo : key
                let filtered = array.filter(
                    (data) => !this.search || (data.customer_name && data.customer_name.toLowerCase().includes(this.search.toLowerCase()))
                )

                if (!result[newKey]) {
                    result[newKey] = [...filtered]
                    return result
                }
                result[newKey] = [...result[newKey], ...filtered]
                return result
            }, {})
        },

        selectedSource() {
            return this.applicationTabView == "compact" ? this.compactApplications : this.localapplications
        },
    },
    watch: {
        applicationTabView(newVal, oldVal) {
            if (newVal == "compact" || newVal == "kanban") {
                this.reInit()
            }
        },
    },
    methods: {
        getCategory(uid, key) {
            let category = this.applicationCategories.find(category => category.uid == uid)
            if (category) {
                return _.get(category, key, '')
            }
        },
        onClickCapture(e, link) {
            if (!this.dragging && !$(e.srcElement).hasClass("table-checkbox")) {
                window.open(`${link}`, "_blank")
            }
        },

        reInit() {
            this.$nextTick(() => {
                this.$refs.applicationKanban.reSlick()
            })
        },

        loadMore(stage) {
            const infiniteScroll = $(".drag-column-" + stage.value + " .drag-inner-list")
            if (infiniteScroll.length > 0) {
                let totalPages = Math.ceil(this.getStageTotal(stage.value) / stage.perPage)
                infiniteScroll.on("scroll", () => {
                    let bottomColumn =
                        _.get(infiniteScroll, '0.scrollTop') +
                        _.get(infiniteScroll, '0.offsetTop') +
                        _.get(infiniteScroll, '0.clientHeight') >=
                        _.get(infiniteScroll, '0.scrollHeight')
                    if (bottomColumn) {
                        stage.busy = stage.page <= totalPages ? true : false
                        stage.page = stage.page < totalPages ? stage.page + 1 : totalPages
                        this.$emit("update-stage", stage)
                    }
                })
            }
        },

        getStageTotal(stage) {
            let items = this.applicationTabView == "compact" ? this.compactApplications[stage] : this.localapplications[stage]
            return items && items.length > 0 ? items.length : 0
        },

        getapplications(stage) {
            let items =
                this.applicationTabView == "compact" ? this.compactApplications[stage.value] : this.localapplications[stage.value]

            setTimeout(() => {
                stage.busy = false
                this.$emit("update-stage", stage)
            }, 1000)

            if (items && items.length && _.get(this.sortby, "prop.sorting")) {
                if (this.sortby.order == "ascending") {
                    if (this.sortby.prop.name == "tasks.due_date") {
                        items.sort((a, b) =>
                            moment(_.get(a, "tasks.due_date", "2000-01-01") + " " + _.get(a, "tasks.time", "17:00:00"), "YYYY/MM/DD hh:mm:ss") >
                            moment(_.get(b, "tasks.due_date", "2000-01-01") + " " + _.get(b, "tasks.time", "17:00:00"), "YYYY/MM/DD hh:mm:ss")
                                ? 1
                                : -1
                        )
                    } else {
                        items.sort((a, b) => (_.get(a, `${this.sortby.prop.name}`) > _.get(b, `${this.sortby.prop.name}`) ? 1 : -1))
                    }
                }
                if (this.sortby.order == "descending") {
                    if (this.sortby.prop.name == "tasks.due_date") {
                        items.sort((a, b) =>
                            moment(_.get(a, "tasks.due_date", "2000-01-01") + " " + _.get(a, "tasks.time", "17:00:00"), "YYYY/MM/DD hh:mm:ss") <
                            moment(_.get(b, "tasks.due_date", "2000-01-01") + " " + _.get(b, "tasks.time", "17:00:00"), "YYYY/MM/DD hh:mm:ss")
                                ? 1
                                : -1
                        )
                    } else {
                        items.sort((a, b) => (_.get(a, `${this.sortby.prop.name}`) < _.get(b, `${this.sortby.prop.name}`) ? 1 : -1))
                    }
                }
            } else if (items && items.length) {
                items.sort((a, b) => (a.updated_at < b.updated_at ? 1 : -1))
            }

            return items && items.length > 0 ? items.slice(0, stage.perPage * stage.page) : []
        },

        tasksModal(application) {
            let task = null
            let create = true
            let applicationId = application.id

            if (application.tasks !== null && application.tasks.status_id == 1) {
                task = application.tasks
                create = false
            }

            if (applicationId) {
                this.$bus.$emit("open-create-modal", {
                    selected: "Task",
                    create: create,
                    applicationId: applicationId,
                    task: task,
                })
            }
        },
        // createTask(applicationId = 1) {
        // 	this.applicationId = applicationId
        // 	this.$bus.$emit("open-create-modal", {
        // 		selected: "Task",
        // 		applicationId: applicationId,
        // 		task: task,
        // 	})
        // },
        // editTaskEmit(data) {
        // 	this.$bus.$emit("open-edit-modal", { data: data, type: "Task" })
        // },
        checkTaskStatus(task) {
            if (task == null || task.status_id != 1) return
            return this.$moment(`${task.due_date} ${task.time}`, "YYYY/MM/DD hhmm").isBefore()
                ? "danger"
                : this.$moment(`${task.due_date} ${task.time}`, "YYYY/MM/DD").isAfter()
                    ? "primary"
                    : "success"
        },
        createNote(application) {
            this.$emit("create-note", application)
        },
        sendMessage(applicationId = 1) {
            this.$bus.$emit("open-create-modal", {
                selected: "Send Message",
                applicationId: applicationId,
            })
        },
        checkSameDay(datetime) {
            return datetime ? this.$moment(datetime).isSame(this.$moment(), 'day') : false
        }
    },

    updated() {
    },

    mounted() {
        if (Ambition.getGlobal("tenant.user.user_settings.disable_card_view_dragging") !== "yes") {
            document.addEventListener("mousedown", () => (this.dragging = false))
            document.addEventListener("mousemove", () => (this.dragging = true))
        }
        if (Ambition.getGlobal("tenant.user.user_settings.disable_card_view_hover") == "yes") {
            this.hover = true
        }
    },
    created() {
    },
}
</script>
<style lang="scss" scoped>

.category-item {
    display: flex !important;
    justify-content: flex-start !important;
    align-items: center !important;
    min-height: 33px;

    .category-dot {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        margin-right: 10px;
    }
}

.checkmark-favicon {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-size: contain;
    border-radius: 100%;
    background-position: center center;
    background-repeat: no-repeat;
}

.app-ref {
    font-weight: 700;
    font-size: 14px;
    min-width: 8.5rem;
}

.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
    border: 1px solid #2493ef;
}

.card-table {
    padding: 0rem 0.3rem;
    position: relative;

    .table {
        max-width: 100% !important;
        border-spacing: 0 5px !important;
        table-layout: fixed;

        tr {
            &:hover {
                background-color: #f9f9f9 !important;
            }

            td {
                &:first-child {
                    width: 7rem;
                    min-width: 7rem;
                    font-weight: bold;
                }

                &:nth-child(2) {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: block;
                }
            }
        }
    }
}

.el-link--inner {
    width: 100%;
}

.card-footer {
    padding: 0.5rem;
    background: #ecf5ff;
}
</style>
<style lang="scss">
.not-called .el-card {
    background-color: #f56c6b;
}

.application-2 {
    //   background: rgba(44, 159, 241, 0.15);
}

.lender-image img {
    max-height: 100% !important;
}

.max {
    &-400 {
        max-width: 400px !important;
    }
}

.slick-track {
    margin-left: -10px;
}

.w-100 .el-link--inner {
    width: 100%;
}

.drag-item .el-tag {

    &.el-tag--danger {
        color: #ffffff !important;
        font-weight: 600 !important;
        background: #F56C6C !important;
        font-size: 0.9rem !important;
    }

    &.el-tag--light {
        color: #ffffff;
        font-weight: 600;
        background: #2493ef;
        font-size: 0.9rem;
    }

    &.el-tag--success {
        ont-weight: 400;
        font-size: 0.7rem;
        color: #ffffff;
        background: #73bd44;
    }

    &.el-tag--grey {
        font-weight: 400;
        font-size: 0.7rem;
        color: #ffffff;
        background: #6f6e6c;
        border-color: #6f6e6c;
    }

    &.el-tag--info-time {
        font-weight: 400;
        font-size: 0.7rem;
        background-color: #f4f4f5;
        border-color: #e9e9eb;
        color: #909399;
    }
}
</style>
